import React from "react";
import { Link } from "react-router-dom";
import styles from "./SharedSpendPolicy.module.css";
import { Container } from "../components/common/Container";

// ── Icons ──────────────────────────────────────────────────────────────────

const ShieldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
  </svg>
);

const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
);

const EnvelopeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
  </svg>
);

const CircleStackIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
  </svg>
);

const CloudIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15a4.5 4.5 0 0 0 4.5 4.5H18a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z" />
  </svg>
);

const CubeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" />
  </svg>
);

const BellIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
  </svg>
);

const ShareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
  </svg>
);

const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
  </svg>
);

const LockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
  </svg>
);

const ScaleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z" />
  </svg>
);

const DocumentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
  </svg>
);

const ListIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
  </svg>
);

const ArrowLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
  </svg>
);

const CheckCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
  </svg>
);

const ExclamationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
  </svg>
);

// ── Components ────────────────────────────────────────────────────────────

interface SectionProps {
  id: string;
  number: string;
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

const Section: React.FC<SectionProps> = ({ id, number, title, icon, children }) => (
  <section id={id} className={styles.section}>
    <div className={styles.sectionHeader}>
      <div className={styles.sectionIcon}>{icon}</div>
      <div className={styles.sectionTitleWrapper}>
        <div className={styles.sectionNumber}>Section {number}</div>
        <h2 className={styles.sectionTitle}>{title}</h2>
      </div>
    </div>
    <div className={styles.sectionBody}>{children}</div>
  </section>
);

const ListItem: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <li className={styles.listItem}>
    <span className={styles.listBullet} />
    <span>{children}</span>
  </li>
);

const sections = [
  { id: "overview", title: "Overview" },
  { id: "waitlist-data", title: "Waitlist Data (Web)" },
  { id: "app-data", title: "In-App Data Collection" },
  { id: "how-we-use", title: "How We Use Your Data" },
  { id: "shared-access", title: "Data Shared Within Your Budget Group" },
  { id: "data-storage", title: "Data Storage" },
  { id: "third-party", title: "Third-Party Services" },
  { id: "notifications", title: "Push Notifications" },
  { id: "data-sharing", title: "Data Sharing with Third Parties" },
  { id: "children", title: "Children's Privacy" },
  { id: "data-deletion", title: "Data Deletion" },
  { id: "data-security", title: "Data Security" },
  { id: "your-rights", title: "Your Rights" },
  { id: "changes", title: "Changes to This Policy" },
  { id: "contact", title: "Contact Us" },
];

export const SharedSpendPolicy: React.FC = () => {
  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <main id="main-content" className={styles.page} role="main" tabIndex={-1}>
      <Container maxWidth="md">
        <Link to="/shared-spend" className={styles.backLink}>
          <ArrowLeftIcon />
          Back to Shared Spend
        </Link>

        <header className={styles.header}>
          <div className={styles.iconWrapper}>
            <ShieldIcon />
          </div>
          <h1 className={styles.title}>Privacy Policy</h1>
          <p className={styles.subtitle}>Shared Spend App</p>
          <div className={styles.meta}>
            <span>Last Updated: {currentDate}</span>
            <span className={styles.metaDot} />
            <span>iOS Application</span>
          </div>
        </header>

        <nav className={styles.toc} aria-label="Table of Contents">
          <h2 className={styles.tocTitle}>
            <ListIcon />
            Table of Contents
          </h2>
          <ul className={styles.tocList}>
            {sections.map((section, index) => (
              <li key={section.id} className={styles.tocItem}>
                <a href={`#${section.id}`} className={styles.tocLink}>
                  <span className={styles.tocNumber}>{String(index + 1).padStart(2, "0")}</span>
                  {section.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.content}>

          <Section id="overview" number="01" title="Overview" icon={<EyeIcon />}>
            <p>
              This privacy policy applies to the Shared Spend mobile application
              for iOS (referred to as "the App") and the Shared Spend website,
              including the waitlist page at dixon-app-development.web.app.
            </p>
            <p>
              Shared Spend is an app that allows users to create and track shared
              budgets with other people. Because the App handles financial data
              that is shared between multiple users, this policy is specific about
              what data is collected, how it is used, and — critically — who else
              can see it within the app.
            </p>
            <p>
              The App is not yet publicly available. This policy covers both
              current data collection (the waitlist) and the data the App will
              collect once it launches.
            </p>
          </Section>

          <Section id="waitlist-data" number="02" title="Waitlist Data (Web)" icon={<EnvelopeIcon />}>
            <p>
              Before the App launches, we collect email addresses from people
              who sign up on our waitlist at dixon-app-development.web.app/shared-spend/waitlist.
            </p>
            <div className={styles.infoCard}>
              <p><strong>What we collect:</strong></p>
              <ul className={styles.list}>
                <ListItem>Your email address</ListItem>
                <ListItem>The timestamp of your submission</ListItem>
              </ul>
            </div>
            <p>
              <strong>How we use it:</strong> We will send you a single email
              notification when the App launches on the App Store. We will not
              send marketing emails, newsletters, or share your email with third
              parties.
            </p>
            <p>
              <strong>To be removed from the waitlist:</strong> Email us at{" "}
              <a href="mailto:dixonappdevelopment@gmail.com" className={styles.link}>
                dixonappdevelopment@gmail.com
              </a>{" "}
              and we will delete your entry within 7 days.
            </p>
            <p>
              Waitlist data is stored in Google Firebase Firestore. See Section
              07 for Firebase's privacy information.
            </p>
          </Section>

          <Section id="app-data" number="03" title="In-App Data Collection" icon={<CircleStackIcon />}>
            <p>
              When the App launches, creating an account and using shared budget
              features will involve collecting the following data:
            </p>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Account Data</h3>
              <ul className={styles.list}>
                <ListItem>
                  <strong>Email address</strong> — used for account identification
                  and sign-in
                </ListItem>
                <ListItem>
                  <strong>Display name</strong> — shown to other users you connect
                  with
                </ListItem>
                <ListItem>
                  <strong>User ID</strong> — a unique identifier for your account
                </ListItem>
                <ListItem>
                  <strong>Authentication provider</strong> — whether you signed in
                  with Apple, Google, or email/password
                </ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Financial Data</h3>
              <div className={styles.notice}>
                <div className={styles.noticeIcon}><ExclamationIcon /></div>
                <p>
                  This data is visible to other members of your shared budgets.
                  See Section 05 for full details on shared access.
                </p>
              </div>
              <ul className={styles.list}>
                <ListItem>
                  <strong>Budget data</strong> — budget names, total amounts,
                  time periods (weekly/monthly/custom), and spending categories
                </ListItem>
                <ListItem>
                  <strong>Expense data</strong> — expense amounts, notes, categories,
                  and the date/time they were logged
                </ListItem>
                <ListItem>
                  <strong>Budget membership</strong> — which users are members of
                  which budgets
                </ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Connection Data</h3>
              <ul className={styles.list}>
                <ListItem>
                  <strong>Connection records</strong> — links between your account
                  and other users you have connected with, including connection
                  status (pending or accepted)
                </ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Device Data</h3>
              <ul className={styles.list}>
                <ListItem>
                  <strong>FCM push token</strong> — a device identifier used to
                  deliver push notifications (see Section 08). This token is
                  stored on our servers and updated when you launch the App.
                </ListItem>
              </ul>
            </div>
          </Section>

          <Section id="how-we-use" number="04" title="How We Use Your Data" icon={<EyeIcon />}>
            <p>We use the data described above only for the following purposes:</p>
            <ul className={styles.list}>
              <ListItem>To authenticate your account and keep it secure</ListItem>
              <ListItem>
                To display your name to other users you connect with and share
                budgets with
              </ListItem>
              <ListItem>
                To store and sync your budgets and expenses across your devices
                and with your budget group members
              </ListItem>
              <ListItem>
                To calculate budget totals and spending progress
              </ListItem>
              <ListItem>
                To send push notifications when your group's budget is approaching
                its limit
              </ListItem>
              <ListItem>
                To send the waitlist launch notification (waitlist signups only)
              </ListItem>
            </ul>
            <p>
              We do not use your data for advertising, profiling, or any purpose
              beyond operating the App.
            </p>
          </Section>

          <Section id="shared-access" number="05" title="Data Shared Within Your Budget Group" icon={<UsersIcon />}>
            <div className={styles.notice}>
              <div className={styles.noticeIcon}><ExclamationIcon /></div>
              <p>
                <strong>This section is important.</strong> Because Shared Spend
                is a collaborative app, some of your data is intentionally
                visible to other users you have connected with.
              </p>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>What other budget members can see</h3>
              <p>
                All members of a shared budget can view:
              </p>
              <ul className={styles.list}>
                <ListItem>The budget name, total amount, and time period</ListItem>
                <ListItem>
                  Every expense logged against that budget — including the amount,
                  note, category, who logged it, and when
                </ListItem>
                <ListItem>
                  The current total amount spent and the remaining balance
                </ListItem>
                <ListItem>The display name of each budget member</ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>What other users cannot see</h3>
              <ul className={styles.list}>
                <ListItem>Your email address</ListItem>
                <ListItem>Your budgets that they are not a member of</ListItem>
                <ListItem>Your account password or authentication details</ListItem>
                <ListItem>Your push notification token</ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Connection visibility</h3>
              <p>
                When you send or receive a connection request, both users can see
                each other's display name and connection status. You control who
                you connect with — you must explicitly accept connection requests.
              </p>
            </div>

            <div className={styles.infoCard}>
              <p>
                This shared access is enforced at the database level by Firebase
                security rules. A user cannot access any budget they are not a
                member of, regardless of how the app is used.
              </p>
            </div>
          </Section>

          <Section id="data-storage" number="06" title="Data Storage" icon={<CloudIcon />}>
            <p>
              All App data is stored in Google Firebase (Firestore), a cloud
              database service. This includes your account data, budget data,
              expense data, connection data, and push notification token.
            </p>
            <p>
              Firebase servers are located in the United States. By using the
              App, you consent to your data being stored and processed there.
            </p>
            <div className={styles.infoCard}>
              <p>
                Firebase security rules are configured to enforce access control:
                your data can only be read or written by authenticated users who
                have explicit permission (e.g., budget members can access their
                shared budget; they cannot access budgets they are not part of).
              </p>
            </div>
          </Section>

          <Section id="third-party" number="07" title="Third-Party Services" icon={<CubeIcon />}>
            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Firebase (Google)</h3>
              <ul className={styles.list}>
                <ListItem>
                  <strong>Firebase Authentication</strong> — manages secure sign-in
                  with Apple, Google, or email/password
                </ListItem>
                <ListItem>
                  <strong>Cloud Firestore</strong> — stores and syncs all app data
                </ListItem>
                <ListItem>
                  <strong>Firebase Cloud Messaging (FCM)</strong> — delivers push
                  notifications to your device
                </ListItem>
              </ul>
              <p>
                Firebase is operated by Google LLC. See the{" "}
                <a
                  href="https://firebase.google.com/support/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  Firebase Privacy Policy
                </a>
                .
              </p>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Apple Services</h3>
              <ul className={styles.list}>
                <ListItem>
                  <strong>Sign in with Apple</strong> — optional authentication
                  method. Apple may provide a relay email address rather than
                  your real one.
                </ListItem>
                <ListItem>
                  <strong>Apple Push Notification Service (APNs)</strong> — used
                  to deliver push notifications to iOS devices
                </ListItem>
              </ul>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Google Sign-In</h3>
              <p>
                If you choose to sign in with Google, Google provides your email
                address and profile name to authenticate your account.
              </p>
            </div>
          </Section>

          <Section id="notifications" number="08" title="Push Notifications" icon={<BellIcon />}>
            <p>
              The App sends push notifications to budget members when the group's
              spending reaches a configured threshold (e.g., 80% of the budget
              limit). This feature:
            </p>
            <ul className={styles.list}>
              <ListItem>Requires your explicit permission when you first open the App</ListItem>
              <ListItem>Is optional and can be disabled at any time in iOS Settings</ListItem>
              <ListItem>
                Works by storing a Firebase Cloud Messaging (FCM) token on our
                servers — this token identifies your device but not your identity
              </ListItem>
              <ListItem>
                Does not transmit your financial data to Apple or FCM — only a
                notification payload (e.g., "Your household budget is at 80%")
              </ListItem>
            </ul>
          </Section>

          <Section id="data-sharing" number="09" title="Data Sharing with Third Parties" icon={<ShareIcon />}>
            <div className={styles.notice}>
              <div className={styles.noticeIcon}><CheckCircleIcon /></div>
              <p><strong>We do not sell your data.</strong> We do not share your
              financial data, email address, or personal information with
              advertisers, data brokers, or marketing companies.</p>
            </div>
            <p>Your data is shared only in these limited circumstances:</p>
            <ul className={styles.list}>
              <ListItem>
                <strong>Infrastructure providers</strong> — your data is stored on
                Firebase (Google) servers as described in Section 07
              </ListItem>
              <ListItem>
                <strong>Other budget members</strong> — as described in Section 05,
                budget and expense data is shared with people you have explicitly
                invited to your budgets
              </ListItem>
              <ListItem>
                <strong>Legal requirements</strong> — if required by applicable
                law, court order, or to protect the rights, property, or safety
                of our users or the public
              </ListItem>
            </ul>
          </Section>

          <Section id="children" number="10" title="Children's Privacy" icon={<UsersIcon />}>
            <p>
              Shared Spend is intended for users aged <strong>13 and older</strong>.
              Because the App handles financial data shared between users, it is
              not suitable for children under 13. We do not knowingly collect
              personal information from children under 13.
            </p>
            <p>
              If you believe a child under 13 has provided us with their
              information, please contact us at{" "}
              <a href="mailto:dixonappdevelopment@gmail.com" className={styles.link}>
                dixonappdevelopment@gmail.com
              </a>{" "}
              and we will delete it promptly.
            </p>
          </Section>

          <Section id="data-deletion" number="11" title="Data Deletion" icon={<TrashIcon />}>
            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>Waitlist (Web)</h3>
              <p>
                To remove your email from our waitlist, email us at{" "}
                <a href="mailto:dixonappdevelopment@gmail.com" className={styles.link}>
                  dixonappdevelopment@gmail.com
                </a>
                . We will delete your entry within 7 days.
              </p>
            </div>

            <div className={styles.subsection}>
              <h3 className={styles.subsectionTitle}>App Account</h3>
              <p>
                To delete your account and associated data after the App launches,
                contact us at{" "}
                <a href="mailto:dixonappdevelopment@gmail.com" className={styles.link}>
                  dixonappdevelopment@gmail.com
                </a>
                .
              </p>
              <ul className={styles.list}>
                <ListItem>
                  We will delete your account, authentication record, and personal
                  data within 30 days
                </ListItem>
                <ListItem>
                  Expense records you logged in shared budgets may be retained in
                  anonymized or aggregate form to preserve accurate budget history
                  for remaining members — your name and identity will be removed
                </ListItem>
                <ListItem>
                  If you are the owner of a budget, deleting your account will
                  also remove that budget and all associated expenses for all
                  members
                </ListItem>
              </ul>
              <div className={styles.infoCard}>
                <p>
                  We will build an in-app account deletion flow after launch. Until
                  then, email requests are the supported method.
                </p>
              </div>
            </div>
          </Section>

          <Section id="data-security" number="12" title="Data Security" icon={<LockIcon />}>
            <p>We protect your data through:</p>
            <ul className={styles.list}>
              <ListItem>
                <strong>Encryption in transit</strong> — all data transmitted
                between the App and Firebase is encrypted via HTTPS/TLS
              </ListItem>
              <ListItem>
                <strong>Encryption at rest</strong> — Firebase encrypts stored
                data at rest by default
              </ListItem>
              <ListItem>
                <strong>Access control</strong> — Firebase security rules ensure
                users can only read and write data they are explicitly authorized
                to access
              </ListItem>
              <ListItem>
                <strong>Authentication</strong> — access requires sign-in via
                Apple, Google, or email/password through Firebase Authentication
              </ListItem>
            </ul>
            <p>
              No system is completely secure. We recommend using a strong, unique
              password and enabling two-factor authentication on your sign-in
              provider account. If you believe your account has been compromised,
              contact us immediately.
            </p>
          </Section>

          <Section id="your-rights" number="13" title="Your Rights" icon={<ScaleIcon />}>
            <p>You have the right to:</p>
            <ul className={styles.list}>
              <ListItem>
                <strong>Access your data</strong> — your budget and expense data
                is visible within the App; account data can be requested via email
              </ListItem>
              <ListItem>
                <strong>Delete your data</strong> — see the Data Deletion section
              </ListItem>
              <ListItem>
                <strong>Remove yourself from the waitlist</strong> — email us to
                unsubscribe at any time
              </ListItem>
              <ListItem>
                <strong>Disable push notifications</strong> — via iOS Settings
                at any time
              </ListItem>
              <ListItem>
                <strong>Leave a shared budget</strong> — you can remove yourself
                from any budget in the App
              </ListItem>
            </ul>
            <p>
              California residents and EU/UK users may have additional rights
              under CCPA and GDPR respectively. To exercise any rights or ask
              questions, contact us at{" "}
              <a href="mailto:dixonappdevelopment@gmail.com" className={styles.link}>
                dixonappdevelopment@gmail.com
              </a>
              .
            </p>
          </Section>

          <Section id="changes" number="14" title="Changes to This Policy" icon={<DocumentIcon />}>
            <p>
              We may update this privacy policy as the App develops and launches.
              Any changes will be reflected on this page with an updated "Last
              Updated" date. For material changes — particularly changes to what
              data is collected or how it is shared — we will notify users through
              the App or by email.
            </p>
            <p>
              We encourage you to review this policy periodically, especially
              before the App's public launch.
            </p>
          </Section>

          <Section id="contact" number="15" title="Contact Us" icon={<EnvelopeIcon />}>
            <p>
              For questions, concerns, data requests, or to exercise your rights
              under this policy:
            </p>
            <div className={styles.contactCard}>
              <div className={styles.contactIcon}>
                <EnvelopeIcon />
              </div>
              <div className={styles.contactDetails}>
                <p className={styles.contactLabel}>Email</p>
                <a
                  href="mailto:dixonappdevelopment@gmail.com"
                  className={styles.contactEmail}
                >
                  dixonappdevelopment@gmail.com
                </a>
              </div>
            </div>
            <p>
              Dixon App Development<br />
              Developer of Shared Spend, Track Habits, and Tide Post
            </p>
          </Section>

        </div>
      </Container>
    </main>
  );
};
